__turbopack_context__.v({
  "root": "Slider-module-scss-module__mNNwmW__root",
});
